import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import {
  FlashMessage,
  Heading,
  SheetLayoutContent,
  SheetLayoutContentWrapper,
  SheetLayoutHeader,
} from '../../../brenger-shared-ui';
import { AutoCompleteInput } from '../../../brenger-shared-ui/components/form/InputAutoComplete';
import { Config } from '../../../config';
import { useTypedSelector } from '../../../hooks';
import { StopType } from '../../../types';
import { isUserLoggedIn } from '../../User/ducks';
import FooterLayout from '../containers/FooterLayout';
import { actions } from '../ducks';
import { useAutoComplete } from '../hooks/useAutoComplete';
import { proceed } from '../proceed';
import { Button } from '@brenger/react';

export const SubStepDestination: React.FC<RouteComponentProps> = ({ location }) => {
  const dispatch = useDispatch();
  const [submitFailed, setSubmitFailed] = React.useState(false);

  const { pickup, delivery } = useTypedSelector(state => state.generalTransport.destination);
  React.useEffect(() => {
    dispatch(actions.setProgress(1));
  }, [location.pathname]);

  const pickupAutoComplete = useAutoComplete({
    currentAddress: pickup,
    setNewAddress: address => dispatch(actions.setDestinationDetails(address, StopType.PICKUP)),
  });
  const deliveryAutoComplete = useAutoComplete({
    currentAddress: delivery,
    setNewAddress: address => dispatch(actions.setDestinationDetails(address, StopType.DELIVERY)),
  });

  const hasError = !pickup || !delivery;

  const submitWidget = (): void => {
    if (!hasError) proceed();
    else setSubmitFailed(true);
  };

  const showAddressBook = useTypedSelector(isUserLoggedIn);

  return (
    <>
      <SheetLayoutContentWrapper>
        <SheetLayoutHeader>
          <Heading size={2}>
            <Translate id={'request_flow.headers.from_to'} />
          </Heading>
        </SheetLayoutHeader>
        <SheetLayoutContent>
          <div style={{ marginBottom: '10px' }}>
            <AutoCompleteInput {...pickupAutoComplete} stopType="pickup" showAddressBook={showAddressBook} />
          </div>
          <AutoCompleteInput {...deliveryAutoComplete} stopType="delivery" showAddressBook={showAddressBook} />
          {hasError && submitFailed && (
            <div className="mt-1">
              <FlashMessage type={'error'} message={'Please select a pickup and delivery location'} />
            </div>
          )}
          {Config.NODE_ENV !== 'production' && (
            <div className="mt-8">
              <Button buttonType="gray-outline" onClick={() => dispatch(actions.resetFlow(true))}>
                reset
              </Button>
            </div>
          )}
        </SheetLayoutContent>
      </SheetLayoutContentWrapper>
      <FooterLayout
        customIsLoading={pickupAutoComplete.isLoading || deliveryAutoComplete.isLoading}
        customSubmitFunction={submitWidget}
      />
    </>
  );
};
